import { useConfig } from '../components/ConfigContext';

export function computeOverlay(glassType, containerSize) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  // console.log(containerSize);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { general } = useConfig();

  let IMAGE_ORIGINAL_WIDTH = 705; // skutečná šířka obrázku v px
  let IMAGE_ORIGINAL_HEIGHT = 834; // skutečná výška obrázku v px

  // default
  let OVERLAY_X = 140,
    OVERLAY_Y = 140,
    OVERLAY_WIDTH = 420,
    OVERLAY_HEIGHT = 380;

  if (general.orientationHorizontal) {
    OVERLAY_X = 80;
    OVERLAY_Y = 225;
    OVERLAY_WIDTH = 360;
    OVERLAY_HEIGHT = 350;
  }

  if (glassType === 'music') {
    OVERLAY_X = 170;
    OVERLAY_Y = 140;
    OVERLAY_WIDTH = 360;
    OVERLAY_HEIGHT = 350;
  }
  if (glassType === 'socials') {
    OVERLAY_X = 175;
    OVERLAY_Y = 180;
    OVERLAY_WIDTH = 350;
    OVERLAY_HEIGHT = 350;
  }
  if (glassType === 'multiple') {
    if (general.orientationHorizontal) {
      OVERLAY_X = 70;
      OVERLAY_Y = 215;
      OVERLAY_WIDTH = 580;
      OVERLAY_HEIGHT = 320;
    } else {
      OVERLAY_X = 120;
      OVERLAY_Y = 120;
      OVERLAY_WIDTH = 455;
      OVERLAY_HEIGHT = 500;
    }
  }

  let scale = Math.max(
    containerSize.width / IMAGE_ORIGINAL_WIDTH,
    containerSize.height / IMAGE_ORIGINAL_HEIGHT
  );

  if (general.orientationHorizontal) {
    scale = containerSize.height / IMAGE_ORIGINAL_HEIGHT;
  }

  const renderedImgWidth = IMAGE_ORIGINAL_WIDTH * scale;
  const renderedImgHeight = IMAGE_ORIGINAL_HEIGHT * scale;
  const offsetX = (renderedImgWidth - containerSize.width) / 2;
  const offsetY = (renderedImgHeight - containerSize.height) / 2;

  return {
    overlayLeft: OVERLAY_X * scale - offsetX,
    overlayTop: OVERLAY_Y * scale - offsetY,
    overlayWidth: OVERLAY_WIDTH * scale,
    overlayHeight: OVERLAY_HEIGHT * scale,
  };
}

function toSeconds(str) {
  const [m, s] = str.split(':').map(Number);
  return m * 60 + s;
}

export function percentToTime(percent, totalMinutes = 4) {
  const totalSeconds = toSeconds(totalMinutes);
  const seconds = Math.round((percent / 100) * totalSeconds);

  const mm = Math.floor(seconds / 60);
  const ss = seconds % 60;

  return `${mm}:${ss.toString().padStart(2, '0')}`;
}

export function timeToPercent(timeStr, totalMinutes = 4) {
  const totalSeconds = toSeconds(totalMinutes);
  // console.log(totalMinutes, toSeconds(totalMinutes));
  const [m, s] = timeStr.split(':').map(Number);
  const currentSeconds = m * 60 + (s || 0);

  return Math.floor((currentSeconds / totalSeconds) * 100);
}
